import { Switch } from "@/components/ui/switch";
import { Label } from "@/components/ui/label";
import { useFieldError } from "@/shared/forms/Field";
import { cn } from "@/shared/lib/utils";
import type * as React from "react";
import { Controller, useFormContext } from "react-hook-form";

type FormSwitchProps = {
  name: string;
  label?: React.ReactNode;
  hint?: React.ReactNode;
  requiredMark?: boolean;
  className?: string;
};

export function FormSwitch({
  name,
  label,
  hint,
  requiredMark,
  className,
}: FormSwitchProps) {
  const { control } = useFormContext();
  const error = useFieldError(name);

  return (
    <div className={cn("space-y-2", className)}>
      <div className="flex items-center gap-2">
        <Controller
          control={control}
          name={name}
          render={({ field }) => (
            <Switch
              id={name}
              checked={!!field.value}
              onCheckedChange={field.onChange}
              onBlur={field.onBlur}
              ref={field.ref}
              aria-invalid={!!error}
            />
          )}
        />
        {label ? (
          <Label htmlFor={name} className="font-normal">
            {label}
            {requiredMark ? <span className="text-destructive"> *</span> : null}
          </Label>
        ) : null}
      </div>
      {error ? (
        <p className="text-destructive text-sm">{error}</p>
      ) : hint ? (
        <p className="text-muted-foreground text-sm">{hint}</p>
      ) : null}
    </div>
  );
}
